import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=6f8923a1&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetail.vue?vue&type=style&index=0&id=6f8923a1&prod&lang=less"
import style1 from "./NoticeDetail.vue?vue&type=style&index=1&id=6f8923a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8923a1",
  null
  
)

export default component.exports